import _ from 'underscore';
import React from 'react';

/**
 * Adapter for Fluent v9 Dropdown that normalizes `selectedOptions` to `string[]`.
 *
 * The validation framework stores field values as plain strings (e.g., 'Phrase'),
 * but Fluent v9 Dropdown always expects `selectedOptions` as `string[]`.
 * This adapter bridges that gap by normalizing the value before passing it
 * to the Dropdown component.
 */
export class FluentDropdownAdapter {
  private component: React.ComponentType<any>;

  constructor(PrimitiveComponent: React.ComponentType<any>) {
    this.component = PrimitiveComponent;
  }

  getValue(props: any) {
    return props.selectedOptions;
  }

  renderComponent(props: any, value: string[] | string | undefined, onChange: (value: string[]) => void) {
    const PrimitiveComponent = this.component;
    let normalizedValue = [];
    if (Array.isArray(value)) {
      normalizedValue = value;
    } else if (value) {
      normalizedValue = [value];
    }

    return (
      <PrimitiveComponent
        {...props}
        selectedOptions={normalizedValue}
        onOptionSelect={(event, { selectedOptions }) => {
          onChange(selectedOptions);
          if (_.isFunction(props.onChange)) {
            props.onChange(selectedOptions);
          }
        }}
      />
    );
  }
}
